import React, { useState } from 'react';
import { FaVideo, FaShoppingCart, FaChartPie, FaShareAlt, FaStar, FaUsers, FaBookOpen } from 'react-icons/fa';
import './Styles.css';
import './ResponsiveService.css';
import ServPic from '../../../assets/bloco_services.svg';
import { AppDownloadModal } from '../../common/AppDownloadModal';

export const BestServices = () => {
    const [isAppModalOpen, setIsAppModalOpen] = useState(false);

    const servicesList = [
        {
            icon: <FaVideo className="service-card-icon" />,
            title: "Interactive Recipe Clubs",
            desc: "Watch step-by-step cooking videos and master secrets from top home chefs."
        },
        {
            icon: <FaShoppingCart className="service-card-icon" />,
            title: "Smart Grocery Checklists",
            desc: "Automated ingredient checklists scaled to your serving count for easy shopping."
        },
        {
            icon: <FaChartPie className="service-card-icon" />,
            title: "Nutritional & Macro Analysis",
            desc: "Detailed calorie and protein breakdowns tailored to Keto, Vegan & Fit diets."
        },
        {
            icon: <FaShareAlt className="service-card-icon" />,
            title: "Instant Recipe Sharing",
            desc: "Share your culinary creations directly with friends and family with one tap."
        }
    ];

    return (
        <section className="services">
            {/* Background illustration */}
            <img src={ServPic} alt="ShareRecipe Community Services" className="services-bg-img" />

            <div className="servicesWrapper">
                <div className="rigthServices">
                    <span className="services-badge">WHAT WE OFFER</span>
                    <h2>The best services ready to serve you</h2>
                    <p className="services-tagline">
                        ShareRecipe brings passionate home cooks and top foodies together with powerful cooking tools and interactive clubs.
                    </p>

                    {/* 2-Column Feature Cards Grid */}
                    <div className="services-features-grid">
                        {servicesList.map((item, idx) => (
                            <div key={idx} className="service-feature-card">
                                <div className="feature-icon-wrapper">
                                    {item.icon}
                                </div>
                                <div className="feature-text">
                                    <h4>{item.title}</h4>
                                    <p>{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Key Stats Counter Bar */}
                    <div className="services-stats-bar">
                        <div className="stat-item">
                            <span className="stat-num"><FaUsers className="stat-icon" /> 50k+</span>
                            <span className="stat-lbl">Home Chefs</span>
                        </div>
                        <div className="stat-divider"></div>
                        <div className="stat-item">
                            <span className="stat-num"><FaBookOpen className="stat-icon" /> 10k+</span>
                            <span className="stat-lbl">Tested Recipes</span>
                        </div>
                        <div className="stat-divider"></div>
                        <div className="stat-item">
                            <span className="stat-num"><FaStar className="stat-icon star" /> 4.9★</span>
                            <span className="stat-lbl">App Rating</span>
                        </div>
                    </div>

                    <button 
                        type="button" 
                        className="explore-services-btn"
                        onClick={() => setIsAppModalOpen(true)}
                    >
                        Explore App Services
                    </button>
                </div>
            </div>

            <AppDownloadModal 
                isOpen={isAppModalOpen}
                onClose={() => setIsAppModalOpen(false)}
                title="Discover ShareRecipe Services"
            />
        </section>
    );
};